import './CustomEmpty.scss';

import { Empty } from 'antd';
import React from 'react';

import NoDataImage from '../../static/images/no_data.svg';

interface Props {
  description?: string;
}

const CustomEmpty = (props: Props) => {
  return (
    <Empty
      image={<NoDataImage width={165} height={157} fill="" />}
      description={props.description}
      className="CustomEmpty"
    />
  );
};

export default CustomEmpty;
